import React, { useState } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";

import { useGetAccountTxsQuery } from "app/services/account";
import { txColumnsToken } from "./columnsConfig";
// import DataTable from "common/DataTable";
// import DataTableTotal from "common/DataTable/DataTableTotal";
import { WrapTable } from "common/TableAccountTxs/styled";
import { DataTableNew } from "common/TableAccountTxs/Table";
import ShowItemOfNumber from "common/TableAccountTxs/ShowItemOfTotal";
import { LinkButton } from "features/extendPages/styled";
import SkeletonTable from "common/SkeletonTable";

export function AccountTxs({ address }: { address: string }) {
  // const [args, setArgs] = useState({
  //   address,
  //   offset: 0,
  //   limit: 20,
  // });
  const { data, isFetching } = useGetAccountTxsQuery({
    address,
    offset: 0,
    limit: 20,
  });
  const newData =
    data?.data?.items &&
    data.data.items.length > 0 &&
    data.data.items.map((item: any) => {
      return { ...item, currentAddress: address };
    });
  return (
    <WrapTable>
      <div style={{ marginBottom: 20 }}>
        <ShowItemOfNumber total={data?.data?.total ? data.data.total : 0} />
      </div>
      {isFetching ? (
        <SkeletonTable type="tx" record={20} loading={isFetching} />
      ) : (
        <DataTableNew
          columns={txColumnsToken}
          data={newData || []}
          loading={isFetching}
        />
      )}
      {data?.data?.total > 20 && (
        <div style={{ textAlign: "center" }}>
          <LinkButton to={`/txs?acc=${address.toLowerCase()}`}>
            View more transaction <ArrowRightOutlined />
          </LinkButton>
        </div>
      )}
    </WrapTable>
    // <DataTable
    //   notBgContentTable="not-bg-content-table"
    //   data={newData ? newData : []}
    //   headerLeft={
    //     <DataTableTotal
    //       total={data?.data?.total ? data.data.total : 0}
    //       type="tx"
    //     />
    //   }
    //   columns={txColumnsToken}
    //   total={data?.data?.total ? data.data.total : 0}
    //   setParams={setArgs}
    //   loading={isLoading}
    // />
  );
}
